<template>
  <div class="flex flex-row relative items-center justify-left" :class='recentlyUsedAssets.length ? "h-16" : ""' >
    <button class='flex-none w-16 h-16' v-for='(asset,i) in recentlyUsedAssets' :key='i' @click='onSelect(asset)'>
      <view-asset :asset='asset' class='h-16' />
    </button>
    <p v-if='recentlyUsedAssets.length' class="pointer-events-none text-white text-sm font-thin absolute left-0 bottom-0">Recently Used</p>
  </div>
</template>
<script>
import ViewAsset from '@/ui/atoms/ViewAsset.vue';
import { mapState } from 'vuex';
export default {
  inject:['api'],
  components:{
    ViewAsset
  },
  methods:{
    onSelect(asset) {
      if (asset.type === 'image') {
        this.$emit('select-image', asset.data);
      } else if (asset.type === 'animation') {
        this.$emit('select-animation', asset.data);
      } else if (asset.type === 'pack') {
        this.$emit('select-pack', asset.data);
      }
    }
  },
  computed:{
    ...mapState(['recentlyUsedAssets'])
  }
}
</script>
